import { useRef, useEffect, useState } from 'react';
import './Contact.css';

const CONTACTS = [
  {
    label: 'email',
    val: 'konwuka24@gmail.com',
    href: 'mailto:konwuka24@gmail.com',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="2" y="4" width="20" height="16" rx="2"/><path d="M22 7L12 13 2 7"/>
      </svg>
    ),
  },
  {
    label: 'github',
    val: 'github.com/Kelechi-Onwuka',
    href: 'https://github.com/Kelechi-Onwuka',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/>
      </svg>
    ),
  },
  {
    label: 'linkedin',
    val: 'linkedin.com/in/kelechionwuka',
    href: 'https://linkedin.com/in/kelechionwuka',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
  },
  {
    label: 'phone',
    val: '781-975-2265',
    href: 'tel:7819752265',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.88 10.6 19.79 19.79 0 01.81 2a2 2 0 012-2.18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L7.09 7.91a16 16 0 006 6l.96-.96a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
      </svg>
    ),
  },
];

function useInView(threshold = 0.2) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setInView(true); obs.disconnect(); }
    }, { threshold });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

export default function Contact() {
  const [ref, inView] = useInView();

  return (
    <section className="section" id="contact">
      <div className="container">
        <div className="section-label">get in touch</div>

        <div className="contact-grid" ref={ref}>
          <div className={`contact-left ${inView ? 'animate-up' : ''}`}>
            <h2 className="section-title contact-title">Let's talk.</h2>
            <p className="contact-intro">
              I'm actively looking for internships and early-career software roles after graduation in May 2026.
              If you're building something interesting and need someone who solves problems with code, let's connect.
            </p>

            <div className="contact-links">
              {CONTACTS.map((c) => (
                <a key={c.label} href={c.href} className="contact-link" target={c.label !== 'phone' && c.label !== 'email' ? '_blank' : undefined} rel="noreferrer">
                  <span className="contact-icon">{c.icon}</span>
                  <div className="contact-info">
                    <span className="contact-label">{c.label}</span>
                    <span className="contact-val">{c.val}</span>
                  </div>
                  <svg className="contact-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2 10L10 2M10 2H4M10 2V8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              ))}
            </div>
          </div>

          <div className={`contact-right ${inView ? 'animate-up' : ''}`} style={{ animationDelay: '0.15s' }}>
            <div className="availability-card terminal-card">
              <div className="terminal-header">
                <span className="dot" style={{ background: '#FF5F57' }} />
                <span className="dot" style={{ background: '#FEBC2E' }} />
                <span className="dot" style={{ background: '#28C840' }} />
                <span className="term-label">availability.status</span>
              </div>
              <div className="avail-body">
                <div className="avail-badge">
                  <div className="pulse-dot" />
                  <span>Open to opportunities</span>
                </div>
                <div className="avail-title">Looking for internships &amp; roles starting Summer 2026.</div>
                <p className="avail-desc">
                  Interested in software engineering, frontend, and product-facing roles.
                  Open to remote, hybrid, or in-person opportunities, especially in Boston.
                </p>
                <a href="mailto:konwuka24@gmail.com" className="avail-cta">
                  Say Hello
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2 10L10 2M10 2H4M10 2V8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-logo"><span style={{ color: 'rgba(0,255,163,0.35)' }}>~/</span>kelechi-onwuka</div>
          <div className="footer-copy">Built with love · {new Date().getFullYear()}</div>
        </div>
      </footer>
    </section>
  );
}
